import React, { useState } from "react";

const PasswordPrompt = ({ onPasswordCorrect }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const correctPassword = "iSync@95959";
    if (password === correctPassword) {
      onPasswordCorrect(true);
    } else {
      setError(true);
    }
  };

  return (
    <div className="password-prompt-container">
      <div className="password-prompt-card">
        <h2 className="password-prompt-title">Enter Password</h2>
        <form onSubmit={handleSubmit} className="password-prompt-form">
          <input
            type="password"
            value={password}
            onChange={handleChange}
            placeholder="Password"
            className="password-prompt-input"
          />
          <button type="submit" className="password-prompt-button">
            Submit
          </button>
        </form>
        {error && (
          <p className="password-prompt-error">
            Incorrect password. Try again.
          </p>
        )}
      </div>
    </div>
  );
};

export default PasswordPrompt;
